// extracted by mini-css-extract-plugin
module.exports = {"scrollItem":"job-summary_scrollItem__3Eyls"};